import { useToaster, toast, Toaster } from 'react-hot-toast';

/**
 * A utitily component for diplaying the notification toasts in the application.
 * It will reside in the top level app component and will be triggered when the
 * notification launcher functions defined below the component are called.
 */
export default function ToastNotification() {
  const { toasts, handlers } = useToaster();
  const { startPause, endPause } = handlers;
  return (
    <div onMouseEnter={startPause} onMouseLeave={endPause}>
      {toasts
        .filter((toast) => toast.visible)
        .map((toast) => (
          <div key={toast.id} {...toast.ariaProps}>
            <Toaster
              position="bottom-left"
              reverseOrder={true}
              toastOptions={{
                className: '',
                duration: 3000,
                success: {
                  theme: {
                    primary: 'white',
                    secondary: 'white',
                  },
                  style: {
                    background: 'green',
                    color: 'white',
                  },
                },
                error: {
                  theme: {
                    primary: 'white',
                    secondary: 'white',
                  },
                  style: {
                    background: 'red',
                    color: 'white',
                  },
                },
              }}
            />
          </div>
        ))}
    </div>
  );
}

// notifications launchers
export const launchCustomNotification = (type, message) => {
  toast[type](message);
};
export const launchSuccessNotification = (message) => {
  toast.success(message);
};
export const launchErrorNotification = (message) => {
  toast.error(message);
};
